import makeAction from '../../../redux/utils/makeAction'
import { DownloadFileAction } from '../types'

const downloadFile = makeAction<DownloadFileAction>('download/FILE')

export default { downloadFile }
